






























































































import { Component, Vue, Prop } from 'vue-property-decorator'

import {
  mdiLogout,
  mdiPhoneOutline,
  mdiEmailOutline,
  mdiFileDocumentOutline,
  mdiHomeAccount,
  mdiAccountOutline,
  mdiEye,
} from '@mdi/js'

import { security } from '@/store/modules/security'
import { settings } from '@/store/modules/settings'
import { Themes } from '@/themes'
import PortalNavigationMenu from '@/components/layouts/PortalNavigationMenu.vue'

@Component({
  components: {
    PortalNavigationMenu,
  },
})
class NavigationMenu extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly open: boolean

  @Prop({
    type: String,
    default: '',
  })
  readonly phone: string

  Themes = Themes

  icons = {
    mdiLogout,
    mdiPhoneOutline,
    mdiFileDocumentOutline,
    mdiEmailOutline,
    mdiHomeAccount,
    mdiAccountOutline,
    mdiEye,
  }

  securityModule = security.context(this.$store)
  settingsModule = settings.context(this.$store)

  get theme() {
    return this.$theme.name
  }

  set theme(theme: Themes) {
    this.$setTheme(theme)
  }
}

export default NavigationMenu
